import * as taskName from './task-name'
import { createUIDefinition } from '../default-task-definition'
import * as processUI from '../../process-ui'
import { selectProcessContext } from '../../../state/instance-detail/selector'
import taskValidator from './cannot-be-treated-validator'

export default createUIDefinition({
    taskName: taskName.PRE_TREATMENT_CHECK,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.INITIAL_HESITATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
        },
        {
            component: processUI.ANAMNESIS_LIST_WIDGET_CONTAINER,
        },
    ],
    taskValidatorSelector: [
        selectProcessContext,
    ],
    taskValidator,
})

// //



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/pre-treatment-check.js